





import { EditScene } from "@/components.edit/edit-scene";

export default {
	components: {
		EditScene
	},
	props:{
		parameters:{
			type:Object,
			required:true
		}
	}
};

